import { render } from "./CartData.vue?vue&type=template&id=0f5d7afc"
import script from "./CartData.vue?vue&type=script&lang=js"
export * from "./CartData.vue?vue&type=script&lang=js"

import "./CartData.vue?vue&type=style&index=0&id=0f5d7afc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__